export const MIN_TOTAL_RATINGS = 3;
export const MAX_RATINGS_PREVIEW_COUNT_LARGE = 6;
export const MAX_RATINGS_PREVIEW_COUNT_MOBILE = 3;
